import { IConfig } from '@cian/config/shared/types';

import { DISTANCE_CALCULATING_ENABLED_CONFIG_KEY } from '../../../constants/map';

export const getIsDistanceCalculatingEnabled = (config: IConfig): boolean => {
  return config.get<boolean>(DISTANCE_CALCULATING_ENABLED_CONFIG_KEY) || false;
};
